<template>
    <v-container>
        <v-layout column>
            <v-layout row justify-start>
                <v-icon @click="back">mdi-arrow-left</v-icon>
                <h2>{{id > 0? `Leverandør`: `Ny leverandør`}}: {{supplier.name}}</h2>
                <!-- <v-spacer></v-spacer> -->
            </v-layout>

            <v-form v-model="valid">
                <v-text-field v-model="supplier.name" :rules="rules.text" label="Navn" :loading="loading" required></v-text-field>
                <v-text-field v-model="supplier.contact" label="Kontakt" required></v-text-field>
                <v-text-field v-model="supplier.phone" label="Tlf" required></v-text-field>
                <v-text-field v-model="supplier.email" label="Epost" required></v-text-field>
                <v-text-field v-model="supplier.web" label="Web" required></v-text-field>
                <v-btn :disabled="!hasChanged || saving || loading" color="warning" @click="cancel" :loading="saving || loading">Angre</v-btn>
                <v-btn :disabled="!hasChanged || saving || loading" color="info" @click="submit" :loading="saving || loading" class="ml-2">Lagre</v-btn>
            </v-form>

        </v-layout>
    </v-container>
</template>

<script>
// import axios from "axios";
import * as equalizer from "../utilities/equalizer.js";

export default {
    props: ["id"],
    data() {
        return {
            saving: false,
            loading: false,
            supplier: {
                id: 0,
                name: "",
                contact: "",
                phone: "",
                email: "",
                web: ""
            },
            originalSupplier: {
                id: 0,
                name: "",
                contact: "",
                phone: "",
                email: "",
                web: ""
            },
            valid: true,
            snackbar: {
                show: false,
                text: "",
                timeout: 2000,
                color: ""
            },
            rules: {
                text: [v => !!v || "Påkrevd"],
                email: [v => (!!v && v.length > 0) || "Epost påkrevd", v => /.+@.+\..+/.test(v) || "Ugyldig epost"]
            }
        };
    },
    methods: {
        back: function() {
            // this.$router.go(-1);
            this.$router.push(`/supplier`);
        },
        cancel: function() {
            this.$store.commit("snackbar", {
                text: `Angret.`,
                color: "warning",
                show: true
            });
            Object.assign(this.supplier, this.originalSupplier);
        },
        submit: function() {
            if (this.id > 0) {
                // EDIT
                this.saving = true;
                this.axios
                    .post(`/supplier/${this.id}`, this.supplier)
                    .then(response => {
                        if (response.data.success) {
                            this.$store.commit("snackbar", {
                                text: `Lagret.`,
                                color: "success",
                                show: true
                            });
                            Object.assign(this.originalSupplier, this.supplier);
                        } else {
                            // TODO: toastr?
                            throw new Error(`POST /supplier/${this.id} failed`);
                        }
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.saving = false;
                    });
            } else {
                // CREATE
                this.saving = true;
                this.axios
                    .put(`/supplier`, this.supplier)
                    .then(response => {
                        if (response.data.success) {
                            this.$store.commit("snackbar", {
                                text: `Lagret.`,
                                color: "success",
                                show: true
                            });

                            this.$router.push(`/supplier/${response.data.data.id}`);
                            Object.assign(this.supplier, response.data.data);
                            Object.assign(this.originalSupplier, this.supplier);
                            // this.downloadSupplier();
                        } else {
                            throw new Error(`PUT /supplier failed`);
                        }
                    })
                    .catch(() => {
                        this.$store.commit("snackbar", {
                            text: "Leverandørnavn eksisterer sannsynligvis allerede.",
                            color: "error",
                            show: "true"
                        });
                    })
                    .finally(() => {
                        this.saving = false;
                    });
            }
        },
        downloadSupplier(){
            this.loading = true;
            if(this.id > 0){
                this.axios
                .get(`/supplier/${this.id}`)
                .then(response => {
                    if (response.data.success) {
                        let supplier = response.data.data;
                        Object.assign(this.supplier, supplier);
                        Object.assign(this.originalSupplier, supplier);
                    }
                })
                .catch(() => {
                    // console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                });
            }
            
        }
    },
    computed: {
        hasChanged: function() {
            return !equalizer.propertiesEqual(
                [
                    { prop: "name", strict: true },
                    { prop: "contact", strict: true },
                    { prop: "phone", strict: true },
                    { prop: "email", strict: true },
                    { prop: "web", strict: true }
                ],
                this.supplier,
                this.originalSupplier
            );
        }
    },
    // watch: {
    //     'route': function(){
    //         let _id = this.id;
    //         console.log(_id);
    //         debugger;
    //         this.downloadSupplier();
    //     }
    // },
    mounted() {
        if (this.id > 0) {
            this.downloadSupplier();
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style scoped>
</style>
